import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../../';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { PackagingSet } from '../../services/FP_FulfillmentContextService/types';
import type { ApplicationErrorOptions } from '../../../types';

export interface PackagingSetsModel {
  packagingSetsMap: Record<string, PackagingSet>;
  setPackagingSets: Action<PackagingSetsModel, PackagingSet[]>;
  setPackagingSet: Action<PackagingSetsModel, PackagingSet>;
  fetchPackagingSetsLoading: boolean;
  setFetchPackagingSetsLoading: Action<PackagingSetsModel, boolean>;
  fetchPackagingSets: Thunk<PackagingSetsModel, void, Injections, StoreModel, Promise<void>>;
  fetchPackagingSetsFailure: Action<PackagingSetsModel, ApplicationErrorOptions>;
}

export const packagingSetsModel: PackagingSetsModel = {
  packagingSetsMap: {},
  setPackagingSets: action((state, packagingSets) => {
    const packagingSetsMap = packagingSets.reduce<Record<string, PackagingSet>>((acc, curr) => {
      acc[curr.packagingSetId] = curr;
      return acc;
    }, {});
    state.packagingSetsMap = packagingSetsMap;
  }),
  setPackagingSet: action((state, packagingSet) => {
    state.packagingSetsMap[packagingSet.packagingSetId] = packagingSet;
  }),
  fetchPackagingSetsLoading: false,
  setFetchPackagingSetsLoading: action((state, isLoading) => {
    state.fetchPackagingSetsLoading = isLoading;
  }),
  fetchPackagingSets: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchPackagingSetsLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchPackagingSets();
      actions.setPackagingSets(response);
      actions.setFetchPackagingSetsLoading(false);
      return response;
    } catch (error) {
      actions.fetchPackagingSetsFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchPackagingSetsLoading(false);
      return error;
    }
  }),
  fetchPackagingSetsFailure: action((state, error) => {
    console.error(error);
  }),
};

export default packagingSetsModel;
